const isPc = true


const glxAiChatPluginIframeId = "glx-ai-chat-plugin-iframe"
const glxAiChatPluginIframeClass = "glx-ai-chat-plugin-iframe"
const glxAiChatPluginId = 'glx-ai-chat-plugin'
const projectName = 'ai-chat-plugin';

const getAiChatPluginIframe = () => {
    return document.getElementById(glxAiChatPluginIframeId) as HTMLIFrameElement
}

export const closeAiChatPlugin = () => {
    const iframe = getAiChatPluginIframe()
    iframe.style.visibility = 'hidden'
}

export const openAiChatPanel = ()=>{
    const iframe = getAiChatPluginIframe()
    iframe.style.visibility = 'visible'
}


/*const showAiChatPlugin = () => {
    const iframe = getAiChatPluginIframe()
    iframe.style.visibility = 'visible'
}*/


export enum ChildEventEnum {
    event1 = 'event1',
    login = 'login',
    close = 'close'
}

export type ChildLoginEventData = {
    clientId: string
    token: string
}

export type ChildEventData = ChildLoginEventData | {}

export enum ParentEventEnum {
    event1 = 'event1',
    init = 'init',
    // login = 'login'
}

export type ParentInitEventData = {
    domain: string
}
// export type ParentLoginEventData = {
//     clientId: string
//     token: string
// }

// export type ParentEventData = ParentInitEventData | ParentLoginEventData
export type ParentEventData = ParentInitEventData | {}

export type ParentMsg<T extends ParentEventData = ParentEventData> = {
    event: ParentEventEnum
    data: T
}

export type ChildMsg<T extends ChildEventData = ChildEventData> = {
    event: ChildEventEnum
    data: T
}

const eventPrefix = `${projectName}:${isPc ? 'pc' : 'mobile'}:`
const childEventPrefix = `${eventPrefix}child:`
const parentEventPrefix = `${eventPrefix}parent:`

/**
 * 父事件工具函数
 * @param event
 */
export const sendMsgToChildCreator = (event: ParentEventEnum) => {
    return (data: ParentEventData = {}) => {
        var eventData: ParentMsg = {
            event,
            data
        }
        // if (!innerIframeDom) {
        //     console.log("glxAiChatPlugin 还没加载")
        //     return;
        // }

        const timer = setInterval(() => {
            const iframeDom = document.getElementById(glxAiChatPluginIframeId) as HTMLIFrameElement;
            if (!iframeDom) {
                return;
            }

            iframeDom.contentWindow?.postMessage(eventData, '*');

            clearInterval(timer);
        }, 1000)

    }
}

export const parentEventRemovePrefix = (parentEventStr: string) => {
    const prefixLength = parentEventPrefix.length
    return parentEventStr.slice(prefixLength)
}

/**
 * 子事件工具函数
 * @param childEventStr
 */
export const childEventRemovePrefix = (childEventStr: string) => {
    const prefixLength = childEventPrefix.length;
    return childEventStr.slice(prefixLength)
}

export const sendMsgToParentCreator = (event: ChildEventEnum) => {
    return (data: ChildEventData = {}) => {
        const msg: ChildMsg = {
            event,
            data
        }

        window.parent.postMessage(
            {...msg, event: `${childEventPrefix}${msg.event}`},
            '*'
        )

        // sendMsgToParent(msg)
    }
}


